import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
	TranslationProviderService,
	CJMHttpClientService,
	MetaService,
	SlicingService,
	LocalStorageService
} from './services';

@NgModule({
	imports: [CommonModule],
	providers: [TranslationProviderService, CJMHttpClientService, MetaService, SlicingService, LocalStorageService]
})
export class SharedCoreModule {}
